import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { LanguageProvider } from './contexts/LanguageContext';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { HomePage } from './pages/HomePage';
import { CaseStudiesPage } from './pages/CaseStudiesPage';
import { ProjectDetailPage } from './pages/ProjectDetailPage';
import { ContactPage } from './pages/ContactPage';
import { AboutPage } from './pages/AboutPage';
import { InsightsPage } from './pages/InsightsPage';
import { ArticleDetailPage } from './pages/ArticleDetailPage';
import SystemsPage from './pages/SystemsPage';

// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return null;
}

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <ScrollToTop />
        <div className="App min-h-screen bg-[#0B0F14] overflow-x-hidden">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/case-studies" element={
              <>
                <Navbar />
                <CaseStudiesPage />
                <Footer />
              </>
            } />
            <Route path="/case-studies/:projectId" element={
              <>
                <Navbar />
                <ProjectDetailPage />
                <Footer />
              </>
            } />
            <Route path="/insights" element={<InsightsPage />} />
            <Route path="/insights/:slug" element={<ArticleDetailPage />} />
            <Route path="/contact" element={
              <>
                <Navbar />
                <ContactPage />
                <Footer />
              </>
            } />
            <Route path="/about" element={
              <>
                <Navbar />
                <AboutPage />
                <Footer />
              </>
            } />
            <Route path="/systems" element={<SystemsPage />} />
          </Routes>
        </div>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
